import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterElektricienPage() {
  return <ClusterPageTemplate clusterName="Elektricien" sectorName="Bouw & Installatie" sectorSlug="bouw-installatie" heroTitle="Website laten maken voor een elektricien" heroDescription="Een professionele website voor jouw installatiebedrijf. Wij bouwen websites die jouw vakkennis uitstralen en zorgen voor een constante stroom aan nieuwe klussen." websiteOnderdelen={[{
    icon: 'WrenchIcon',
    title: 'Diensten',
    description: 'Van groepenkasten vervangen tot zonnepanelen installeren: een helder overzicht van wat je doet.'
  }, {
    icon: 'ShieldCheckIcon',
    title: 'Certificeringen',
    description: 'Toon je zegels, keurmerken (zoals NEN 3140) en erkenningen om direct vertrouwen te wekken.'
  }, {
    icon: 'PhoneIcon',
    title: 'Storingsdienst',
    description: 'Een duidelijke sectie voor spoedgevallen en stroomstoringen met een opvallende bel-knop.'
  }, {
    icon: 'FileTextIcon',
    title: 'Offerte aanvragen',
    description: 'Een makkelijk formulier voor grotere projecten zoals het aanleggen van elektra in een nieuwbouwwoning.'
  }]} functionaliteiten={[{
    icon: 'SearchIcon',
    title: 'Lokale SEO',
    description: 'Zorg dat je bovenaan staat in Google wanneer mensen in jouw regio zoeken naar een erkend elektricien.'
  }, {
    icon: 'MessageSquareIcon',
    title: 'WhatsApp integratie',
    description: 'Laat klanten makkelijk een foto sturen van hun meterkast via WhatsApp voor een snelle inschatting.'
  }, {
    icon: 'PhoneIcon',
    title: 'Click-to-call',
    description: 'Een zwevende bel-knop op mobiel zodat mensen met een stroomstoring je direct kunnen bereiken.'
  }]} siblingClusters={[{
    name: 'Bouwbedrijf',
    slug: 'bouwbedrijf'
  }, {
    name: 'Loodgieter',
    slug: 'loodgieter'
  }, {
    name: 'Dakdekker',
    slug: 'dakdekker'
  }]} faqs={[{
    q: 'Wat kost een website voor een elektricien?',
    a: "Een professionele website start vanaf €1.500. Dit is inclusief het inrichten van je dienstenpagina's en basis SEO-optimalisatie."
  }, {
    q: 'Hoe lang duurt het om de website te maken?',
    a: 'Gemiddeld leveren we een website voor een installatiebedrijf op binnen 2 tot 4 weken.'
  }, {
    q: 'Word ik ook gevonden door zakelijke klanten (B2B)?',
    a: "Ja, we kunnen de website zo inrichten dat deze zowel particulieren als zakelijke opdrachtgevers (zoals aannemers of VvE's) aanspreekt."
  }, {
    q: "Kan ik zelf teksten of foto's aanpassen?",
    a: 'Ja, de website wordt gebouwd in WordPress met een gebruiksvriendelijk systeem waardoor je zelf makkelijk aanpassingen kunt doen.'
  }]} data-id="element-1079" />;
}